/** An underlying string that is a valid URL. */
export type Url = string;

function hasHypertextTransferScheme(url: Url): boolean {
  return url.startsWith('http://') || url.startsWith('https://');
}

/** Checks a URL for its scheme and adds it if not present.
 *
 * For all intents and purposes we're not going to be seeing any `tcp://` or `ftp://` added by CDAs so we can just check for the hypertext
 * transfer protocols.
 *
 * HTTP seems like the more sensible default because servers with HTTPS will redirect to it. If we defaulted to HTTPS we would end up
 * directing users to the certificate not found page. */
export function withScheme(url: Url): Url {
  if (hasHypertextTransferScheme(url)) return url;

  return `http://${url}`;
}
